import { modifier } from 'ember-modifier';

import { hashCode } from 'webapp/utils/number';

// observer for changes in some object, similar to did-update
// but only calls onChange on actual data change (keeps previous hash)
// calls onChange on init AND when the data has changed
// only one per element supported, bcos of attribute name

const DataAttributeName = 'hash';

type OnChangeFn = (isInit: boolean) => void;

type DataItemType = object | string | number | boolean | undefined | null;

const didCacheUpdateModifier = modifier(
	(node: HTMLElement, [onChange, ...data]: [OnChangeFn, ...DataItemType[]]) => {
		const dataAttributeName = `data-${DataAttributeName}`;
		const currentHash = node.getAttribute(dataAttributeName);

		const getHashForItem = (item: DataItemType) => {
			const hashForItem =
				typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'
					? String(item)
					: String(hashCode(JSON.stringify(item || {})));
			return hashForItem;
		};

		const newHashParts: string[] = [];
		data.forEach((item) => {
			const itemArray = Array.isArray(item) ? (item as DataItemType[]) : [item];
			itemArray.forEach((item) => {
				const newHashPart = getHashForItem(item);
				newHashParts.push(newHashPart);
			});
		});

		const newHash = newHashParts.join('-');
		if (currentHash !== newHash) {
			onChange(!currentHash);
			node.setAttribute(dataAttributeName, newHash);
		}

		return () => {
			// do not remove the data attribute
			// bcos this will reinitialize on "data" change
			// and we still need to check for changes
		};
	},
);

export default didCacheUpdateModifier;
